export function SomewhereAlongTheWay() {
  return (
    <section
      data-testid="believing-happy-somewhere-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-[53px] md:pt-[70px] pb-[40px] md:pb-[53px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-8 md:gap-y-10">

          {/* Eyebrow + Headline — anchored left */}
          <div className="lg:col-span-7 lg:col-start-1 reveal">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              Somewhere Along the Way
            </p>
            <h2
              data-testid="believing-happy-somewhere-headline"
              className="font-display text-[34px] sm:text-[44px] lg:text-[52px] leading-[1.12] tracking-tight text-[#1C1917] max-w-xl"
            >
              You got really good at being reasonable.
            </h2>
          </div>

          {/* Body — offset right, staggered beneath the headline */}
          <div className="lg:col-span-8 lg:col-start-5 reveal">
            <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl">
              <p>You learned how to handle what needed handling.</p>
              <p>
                To make the practical choice.
                <br />
                Keep things moving.
                <br />
                Be grateful for what you have.
              </p>
              <p className="text-[#1C1917]">And none of that was wrong.</p>
              <p>
                It may have helped you build a life you&rsquo;re genuinely
                proud of.
              </p>
              <p>
                But somewhere between being responsible and being realistic,
                you may have stopped asking a different question:
              </p>
            </div>
          </div>

          {/* Turning point — generous breathing room, offset further right */}
          <div className="lg:col-span-9 lg:col-start-4 pt-[19px] md:pt-[29px] pb-[18px] md:pb-[27px] reveal">
            <p
              data-testid="believing-happy-somewhere-turning-point"
              className="font-display italic text-[28px] sm:text-[34px] md:text-[40px] lg:text-[44px] leading-[1.25] text-[#1C1917] max-w-2xl"
            >
              What would make me feel more alive?
            </p>
          </div>

          {/* Negations — indented further right, quiet secondary tone */}
          <div className="lg:col-span-6 lg:col-start-6 reveal">
            <div className="space-y-2 text-base md:text-lg leading-relaxed italic text-[#8A8580]">
              <p>Not what should you want.</p>
              <p>Not what makes the most sense.</p>
              <p>Not what would impress anyone.</p>
            </div>
            <p className="mt-6 text-lg md:text-xl text-[#57534E]">Just&hellip;</p>
          </div>

          {/* Final teal visual punctuation */}
          <div className="lg:col-span-6 lg:col-start-7 pt-[20px] md:pt-[34px] reveal">
            <p
              data-testid="believing-happy-somewhere-final-line"
              className="font-display text-[38px] sm:text-[48px] lg:text-[56px] leading-[1.05] tracking-tight text-[#159E9A]"
            >
              What do you want?
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
